/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type MatchingRequest = {
  data: {
    score?: number
    type?: MatchingRequest.type
    identifier: string
  }
}
export namespace MatchingRequest {
  export enum type {
    TAGS = 'tags',
    CULTURE = 'culture',
    PERSONALITY = 'personality',
    COGNITIVE = 'cognitive',
    MOTIVATIONS = 'motivations',
    TOTAL = 'total',
  }
}
